import axios from "axios"
import { apiUrl } from "../../url";
import { JWT } from "../auth/user";


const axios1 = axios.create({
 baseURL: apiUrl,
})
axios1.defaults.headers.common["Authorization"] = `Bearer ${JWT}`

export async function get(url, config = {

}) {
 return await axios1.get(url, { ...config }).then(response => response.data).catch(err => {
  console.log('err1s', err);
 })
}

export async function getAllData(url , error) {
 // try {
 //  const response = await axios({
 //   method: "GET",
 //   url: `${apiUrl + url}`,
 //   headers: {
 //    Accept: "application/json",
 //    "Content-Type": "application/json",
 //    "Accept-Language": "en",
 //    Authorization: `Bearer ${JWT}`,
 //   },
 //  });

 //  return response.data;
 // } catch (err) {
 //  console.log(err);
 // }

 
}